import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { useState } from 'react'

import { css } from '@emotion/react'

import { Parking } from '@/service'
import Button from '@/components/common/Button'

import { mediaUp } from '@/styles/media'

import ManualOperationModal from './ManualOperationModal'

interface Props {
  parking: Parking
}

function BookParkingButtons(props: Props) {
  const { parking } = props
  const { t } = useTranslation('common')
  const router = useRouter()

  const [isPopupOpen, setIsPopupOpen] = useState(false)

  const comingSoon =
    !parking.subscriptionAvailable &&
    !parking.reservationAvailable &&
    parking.additionalInfo === 'COMING_SOON'
  const manualOperation =
    comingSoon && parking.urlSlug === 'goshi-village-dubai'
  const noSpots =
    parking.subscriptionAvailable &&
    parking.reservationAvailable &&
    parking.additionalInfo === 'NO_SPOTS'
  const bookReservation =
    parking.reservationAvailable && parking.additionalInfo !== 'NO_SPOTS'
  const bookSubscription =
    parking.subscriptionAvailable && parking.additionalInfo !== 'NO_SPOTS'
  const unavailable = parking.additionalInfo === 'UNAVAILABLE'
  const parkWithNavipay =
    !parking.subscriptionAvailable &&
    !parking.reservationAvailable &&
    parking.additionalInfo !== 'COMING_SOON' &&
    parking.additionalInfo !== 'UNAVAILABLE'

  const handleClick = (hash: string) => {
    const element = document.getElementById(hash)
    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'nearest'
    })
  }

  const handleOpenModal = () => {
    setIsPopupOpen(true)
  }

  const handleRedirectToReservation = () => {
    router.push({
      pathname: '/reservation',
      query: {
        parking: parking.urlSlug,
        minimumNoticeTimeMinutes: parking.minimumNoticeTimeMinutes,
        latitude: parking.lat,
        longitude: parking.lon
      }
    })
  }

  const handleNaviPayClick = () => {
    router.push({
      pathname: '/navipay'
    })
  }

  return (
    <>
      {bookReservation && (
        <Button
          css={button}
          text={t('buttonReservation')}
          onClick={() => handleRedirectToReservation()}
        />
      )}
      {bookSubscription && (
        <Button
          css={button}
          text={t('buttonSubscription')}
          onClick={() => handleClick('subscription-section')}
        />
      )}
      {noSpots && (
        <Button
          css={button}
          style={'disabled'}
          text={t('buttonNoSpots')}
          onClick={() => handleClick('no-spots-section')}
        />
      )}
      {manualOperation ? (
        <Button
          css={button}
          text={t('manualOperation')}
          onClick={() => handleOpenModal()}
        />
      ) : comingSoon ? (
        <Button css={button} disabled text={t('buttonComingSoon')} />
      ) : null}
      {parkWithNavipay && (
        <Button
          css={button}
          text={t('buttonNavipay')}
          onClick={() => handleNaviPayClick()}
        />
      )}
      {unavailable && (
        <Button css={button} text={t('buttonUnavailable')} disabled />
      )}

      {isPopupOpen && (
        <ManualOperationModal onCancel={() => setIsPopupOpen(false)} />
      )}
    </>
  )
}

const button = css`
  margin-inline-end: 5px;

  ${mediaUp('md')} {
    margin-inline-end: 10px;
  }

  ${mediaUp('lg')} {
    margin-inline-end: 20px;
  }

  &:last-of-type {
    margin-inline-end: 0;
  }
`

export default BookParkingButtons
